module.exports = __webpack_public_path__ + "img/pillow.f51085eb.svg";